import { Dialog, DialogTitle } from '@mui/material'
import { useCallback, useState } from 'react'

import {
  CannedJobCustomPartEntry,
  CannedJobInventoryPartEntry,
  CannedJobToInventoryProductEntry,
  InventoryPartEntry
} from '../../../sdk'
import { SearchInventoryFormWrapperForCannedJob } from './SearchInventoryFormWrapperForCannedJob'

export const useAddCannedJobInventoryDialog = () => {
  const [customProps, setCustomProps] = useState<
    | {
        cannedJobId: string
        existingEntry: CannedJobInventoryPartEntry | undefined
        inventoryEntry: InventoryPartEntry | undefined
        existingCannedJobToProductEntry:
          | CannedJobToInventoryProductEntry
          | undefined
        productEntry: CannedJobCustomPartEntry | undefined
      }
    | undefined
  >()

  const AddCannedJobInventoryPartDialog = useCallback(() => {
    return (
      <>
        {customProps && (
          <Dialog open={true} fullWidth={true} maxWidth={'sm'}>
            <DialogTitle data-testid="dialogTitle">
              {customProps.existingEntry ||
              customProps.existingCannedJobToProductEntry
                ? 'Edit'
                : 'Add'}{' '}
              Inventory Part
            </DialogTitle>
            <SearchInventoryFormWrapperForCannedJob
              cancelCallback={() => setCustomProps(undefined)}
              {...customProps}
            />
          </Dialog>
        )}
      </>
    )
  }, [customProps])
  return {
    setCustomProps,
    AddCannedJobInventoryPartDialog
  }
}
